// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2q4Jb","footer":"ModalCreateQualiphyProcedure_footer__1oA13","additionData":"ModalCreateQualiphyProcedure_additionData__2OQVT"};